import { Api } from '../services/api/axiosApi';
import { ApiLogin } from '../services/api/axiosLogin';

// Único arquivo de shared/offline que muda entre PDVSIAC e FrontSIAC — o
// resto da pasta é idêntico nos dois (mesmo banco local, mesma fila, mesma
// sincronização). Aqui ficam só as ligações com o app: as instâncias do
// axios, a URL do servidor e como aplicar um token novo.

export { Api, ApiLogin };

export const URL_BASE = window.env.REACT_APP_URL_BASE;

// Operação "Orçamento" — não movimenta estoque, então a venda nessa operação
// não passa pela conferência de estoque antes do envio (ver sincronizacao.ts).
export const ID_OPERACAO_ORCAMENTO: string = window.env.REACT_APP_IDORCAMENTO || '';

// No FrontSIAC os interceptors leem o token do localStorage a cada
// requisição (ver axiosApi/axiosLogin) — basta gravar lá.
export const aplicarToken = (token: string) => {
  localStorage.setItem('APP_ACCESS_TOKEN', JSON.stringify(token));
};
